import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UserRoles, {MANAGER_PLUS_ROLES} from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Users',
	url: '/users',
	icon: 'user',
}];

class Users extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					{this.props.roles.some(role => MANAGER_PLUS_ROLES.includes(role)) &&
					<Button data-id="add-user" onClick={this.toggle('modalUserAdd')} size="sm" color="primary">
						<i className="fa fa-user"/>&nbsp;&nbsp;Add User
					</Button>
					}
				</Framework.Components.PageBar>

				<Collections.Users
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={this.props.roles.includes(UserRoles.Admin)}
					roles={this.props.roles}
				/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"User"}
					object={Objects.User}
					history={this.props.history}
					toggle={this.state.modalUserAdd}
					reportClose={this.reportClose('modalUserAdd')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					size={"xl"}
					objectProps={{ roles: this.props.roles, hasModal: true}}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(Users);

